import { API } from '@portals/redux';
import {
  replaceNormalizedData,
  updateNormalizedData,
} from '@portals/redux/actions/data';
import { DEVICE_SCHEMA } from '@portals/redux/schemas';

// TODO: Remove this action, currently used for Finance's Overview demo data
export const getDevices = () => ({
  type: API,
  payload: {
    url: 'ui/partner/devices',
    normalize: [DEVICE_SCHEMA],
    success: replaceNormalizedData('devices'),
    name: 'getDevices',
  },
});

// TODO: Remove this action, currently used for Integration testing
export const getDevice = (id) => ({
  type: API,
  payload: {
    url: `ui/partner/devices/${id}`,
    normalize: DEVICE_SCHEMA,
    success: updateNormalizedData('devices'),
    name: `getDevice_${id}`,
  },
});
